import React, { useState } from 'react';
import styles from './FocusLearningPaths.module.scss';
import { imageBasePath } from 'constants';
import { format, parseISO } from 'date-fns';
import DeadlineBubble from '../common/DeadlineChip';
import icon_arrow_active from 'assets/learningPaths/Arrow_active.svg';
import { ConfirmationDialog } from 'shared_elements';
import icon_Focus_LP from 'assets/learningPaths/Focus_play.svg';
import icon_File_LP from 'assets/learningPaths/FileLP.svg';
import time_LP from 'assets/learningPaths/time_LP.svg';
import calendar_LP from 'assets/learningPaths/calendar_LP.svg';
import content_LP from 'assets/learningPaths/content_LP.svg';
import person_LP from 'assets/learningPaths/person_LP.svg';
import { useGetFF } from '@fstack-tech/ff_react_module';
import ModuleAssessmentCardButton from 'features/training/assessment/ModuleBased/ModuleAssessmentCardButton';
import UserAssesmentDialog from 'features/training/components/UserAssesmentDialog';
const FocusContentCard = ({
  contentData,
  onClick_ = null,
  isAdminView = false,
  handleRemove = null,
  isAddNewModule = false,
  isPathOwner = true,
}) => {
  const {
    uuid,
    content_count,
    title,
    description,
    deadline,
    published_at,
    created_by,
    estimated_duration,
  } = contentData?.content || {};
  const { status } = contentData || {};
  const [showModal, setShowModal] = useState(false);
  const [deleteLoader, setDeleteLoader] = useState(false);
  const handleClickDelete = () => setShowModal(true);
  const { isEnabled: ff_learningPaths } = useGetFF({ flag_id: 'learning_paths' });
  const [userAssesmentDialog, setUserAssesmentDialog] = useState(false);
  const { isEnabled: moduleAssessmentEnabled } = useGetFF({ flag_id: 'module_base_assessment' });

  return (
    <div className={`${styles.main}`}>
      <ConfirmationDialog
        open={showModal}
        title={
          <>Are you sure you want to remove this {ff_learningPaths ? 'skill set?' : 'module?'}</>
        }
        description=""
        acceptText="Yes, Remove"
        rejectText="No, Cancel"
        isDelete={true}
        image={imageBasePath + 'delete_confirmation.svg'}
        handleClose={() => {
          setShowModal(false);
          setDeleteLoader(false);
        }}
        handleSubmit={() => {
          handleRemove(uuid);
          setShowModal(false);
        }}
        loader={deleteLoader}
      />
      <div className={styles.FocusMainText}>
        <div className={styles.FocusHeaderText}>
          {!isAddNewModule && (
            <div className={styles.FocusHeaderTitle} onClick={onClick_}>
              <img
                src={isAdminView ? icon_File_LP : icon_Focus_LP}
                alt="icon"
                className={styles.icon}
              />
              <div className={styles.FocusHeaderTextTitle}>{title}</div>
            </div>
          )}
          {!isAdminView
            ? !isAddNewModule && (
                <div style={{ minHeight: '3.5rem' }}>
                  <ModuleAssessmentCardButton
                    isEnabled={moduleAssessmentEnabled}
                    module={{
                      ...contentData?.content,
                      is_completed: contentData?.status === 3 ? true : false,
                    }}
                    setUserAssesmentDialog={setUserAssesmentDialog}
                    isRepView={true}
                  />
                </div>
              )
            : isPathOwner && (
                <div className={styles.deleteIcon}>
                  <img
                    src={imageBasePath + 'deleteIconLP.svg'}
                    alt="Delete"
                    onClick={() => handleClickDelete()}
                    className={styles.delete}
                  />
                </div>
              )}
        </div>
        {description.length > 0 ? (
          <div className={styles.FocusDescription} onClick={onClick_}>
            {description}
          </div>
        ) : (
          <div className={styles.focusNoDescription} onClick={onClick_}>
            No description provided
          </div>
        )}
        <div className={styles.FocusBubblesContainer} onClick={onClick_}>
          <div>
            <img src={person_LP} alt="icon" />
            {`${created_by.first_name} ${created_by.last_name}`}
          </div>
          {published_at && (
            <div>
              <img src={calendar_LP} alt="icon" />
              Published on {format(parseISO(published_at), 'MMM dd, yyyy')}{' '}
            </div>
          )}
          <div>
            <img src={content_LP} alt="icon" />
            {content_count} Resources added
          </div>
          <div>
            <img src={time_LP} alt="icon" />
            {estimated_duration} min.
          </div>
        </div>
        <DeadlineBubble deadline={deadline} />
      </div>
    </div>
  );
};

export default FocusContentCard;
